import type { UseFormReturnType } from '@mantine/form';

import { useTranslation } from 'react-i18next';

import { Select } from '../../../../../../../shared/components/UI/Select/Select';

import { VaultPropertyType } from '../../../../../../../shared/entities/VaultProperty';
import type { FormValues } from '../hooks/useVaultPropertyForm';

export function VaultPropertyTypeSelect({
  form,
  disabled,
}: {
  form: UseFormReturnType<FormValues>;
  disabled?: boolean;
}) {
  const { t } = useTranslation(['bidResponse']);

  const selectData = [
    { value: VaultPropertyType.SELECT, label: 'Select' },
    { value: VaultPropertyType.MULTISELECT, label: 'Multi-select' },
  ];

  return (
    <Select
      {...form.getInputProps('type')}
      variant="filled"
      defaultValue={VaultPropertyType.SELECT}
      label={t('vault.sidepanels.createProperty.input.type.label')}
      placeholder={t('vault.sidepanels.createProperty.input.type.placeholder')}
      data={selectData}
      disabled={disabled}
    />
  );
}
